module.exports = __webpack_public_path__ + "img/action-comment-hover.7a34826e.svg";